import type React from 'react'
import { useEffect, useRef, useState } from 'react'

import { logger } from '../../lib/logger'
import { i18n } from '../../shared/i18n'
import {
  initializeGoogleAuth,
  loadGoogleScript,
  tryGoogleOneTap,
} from '../../lib/social-auth/google-auth'

export function useGoogleSignInButton(onCredential: (credential: string) => void): {
  containerRef: React.RefObject<HTMLDivElement | null>
  error: string | null
} {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const [error, setError] = useState<string | null>(null)
  const onCredentialRef = useRef(onCredential)
  onCredentialRef.current = onCredential

  useEffect(() => {
    loadGoogleScript()
      .then(() => {
        initializeGoogleAuth((credential) => onCredentialRef.current(credential))

        if (containerRef.current) {
          google.accounts.id.renderButton(containerRef.current, {
            type: 'standard',
            theme: 'outline',
            size: 'large',
            width: 352,
          })
        }

        tryGoogleOneTap()
      })
      .catch((error_: unknown) => {
        const message =
          error_ instanceof Error ? error_.message : i18n.t('common.errors.sdkLoadFailed')
        logger.error('[GoogleSignInButton]', error_)
        setError(message)
      })
  }, [])

  return { containerRef, error }
}
